'use client';
import React, { useEffect, useState } from 'react';
import './Index.css';
import { Box, Paper, SortDirection, Stack, Typography } from '@mui/material';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useStore } from '../../../utils/store';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import StatusRequestData from '../../../Models/StatusRequest';
import { useNavigate } from 'react-router-dom';
import SwitchComponent from '../../../components/SwitchComponent';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import { useSearch } from '../../../components/searchContext';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';

const Customer: React.FC = () => {
  const { getAdmin } = useStore();
  const { searchQuery } = useSearch();
  const navigate = useNavigate();
  // Table Columns Definition
  const columns: any[] = [
    { field: 'name', headerName: 'Name' },
    { field: 'address', headerName: 'Address' },
    { field: 'phone', headerName: 'Phone Number' },
    { field: 'email', headerName: 'Email Address' },
    // { field: 'customerID', headerName: 'Customer ID' },
    { field: 'creditLimit', headerName: 'Credit Limit' },
    {
      field: 'openQuotes',
      headerName: 'Open Quotes',
    },
    {
      field: 'acceptedQuotes',
      headerName: 'Accepted Quotes &  Live Projects',
    },
    {
      field: 'totalExposure',
      headerName: 'Total Exposure',
    },
    {
      field: 'status',
      headerName: 'Active',
      disableSort: true,
      renderCell: (value: any) => (
        <SwitchComponent
          checked={value === '1'}
          value={value}
          size="small"
          color="success"
          inputProps={{ 'aria-label': 'controlled' }}
          name={'customerstatus'}
          handleInputChange={() => {}}
        />
      ),
    },
    {
      field: 'updated',
      headerName: 'Date Modified',
      valueGetter: (value: any) =>
        new Date(value).toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }),
    },
  ];
  // State Management
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState<any[]>([]);
  const [orderBy, setOrderBy] = useState<any>('updated');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  const [paginate, setPaginate] = useState({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });

  useEffect(() => {
    fetchData();
  }, [searchQuery, paginate]);

  // Fetch Data
  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.customersURL,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { search: searchQuery, limit: paginate.limit, offset: paginate.offset }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('name');
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handlePagination = (paginationData: any) => setPaginate(paginationData);

  const handleStatus = (row: any) => {
    let status = '1';
    if (row.status === '1') {
      status = '0';
    }
    if (row.status === '0') {
      status = '1';
    }
    StatusUpdate({ id: row.id, status: status });
  };

  const StatusUpdate = async (dataObj: StatusRequestData) => {
    try {
      const response = await HttpService.patch(
        Constants.apiURL + Constants.customersURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        fetchData();
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  return (
    <Stack>
      <Box id="main" className="main dashboardmain">
        <section className="section dashboard">
          <div className="containergrid">
            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  mb: 2,
                }}
              >
                <Typography variant="h6">All Customers</Typography>
                <AddButtonComponent
                  onClick={() => {
                    navigate('/data-management/customer/Add');
                    //setDialogOpen(true);
                  }}
                  keyName="quoteaddicon"
                  label="Add New"
                />
              </Box>
              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                order={order}
                handleOrderBy={handleOrderBy}
                orderBy={orderBy}
                totalRecords={totalRecords}
                handlePagination={handlePagination}
                handleRowClick={(row: any) => {
                  navigate('/data-management/customer/' + row.id);
                }}
                handleStatus={handleStatus}
                paginationModel={{
                  page: paginate.offset,
                  pageSize: paginate.limit,
                }}
              />
            </Paper>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default Customer;
